// extracted by mini-css-extract-plugin
export default {"gridImage":"ITdOuH9jIcPW_E6JaW3u","image":"rIoS9_CvpURLOqnAlQAZ","deleteBtn":"La9NTRYB0FMuS8I7Pa2a","info":"JhSo1lvzbixxymXYkybZ","fade-in":"ro8NZA7TXSWGX_KY0UQc"};